import dayjs from "dayjs";
import { ScheduleType } from "../components/schedule/components/week/week-types";


export const generateScheduleCSV = (
  events: ScheduleType[],
  selectedWeek: string[]
): string => {
  // Create CSV header
  const header = ['Employee', 'Date', 'Schedule Time', 'Status'];
  const rows = [header];

  // Generate rows for each event
  events.forEach(event => {
    // For each week in selectedWeek (could be 1 or 2 weeks)
    selectedWeek.forEach((weekStart) => {
      // For each day of the week (0-6 Sunday to Saturday)
      for (let dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
        // Get the schedules for this day of week from the event
        const daySchedules = event.days[dayOfWeek] || [];
        
        // Calculate the actual calendar date
        const dayDate = dayjs(weekStart).add(dayOfWeek, 'day').format('YYYY-MM-DD');
        
        // Add a row for each schedule on this day
        daySchedules.forEach((schedule) => {
          rows.push([
            event.name,
            dayDate,
            schedule.time,
            schedule.tag || 'Scheduled',
          ]);
        });
      }
    });
  });

  // Convert to CSV format
  return rows.map(row => row.map(cell => `"${cell}"`).join(',')).join('\n');
};


export const downloadCSV = (csvContent: string, filename: string) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  const navAny = window.navigator as unknown as Record<string, unknown>;
  if (navAny.msSaveBlob) {
    // IE 10+
    const msSaveBlob = navAny.msSaveBlob as (blob: Blob, name: string) => void;
    msSaveBlob(blob, filename);
  } else {
    // Other browsers
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};